<template>
  <component
    :is="is"
    class="video-list__video-item m-[1.5vw] video-preview-box video-preview-box-hover"
  >
    <router-link
      :to="to"
      class="video-list__video-item__link relative items-center flex flex-col h-full"
    >
      <img
        :src="transformPublicUrl(video.previewImage?.publicUrl)"
        :alt="video.title"
        :title="video.title"
        class="max-w-[21vw]"
      />
      <div
        class="video-list__video-item__title video-preview-box__title text-black self-stretch grow p-[10px] text-center"
      >
        {{ video.title }}
      </div>
      <ul class="absolute inset-0 text-right p-2">
        <li
          v-for="tag in tags"
          :key="tag.slug"
          class="inline-block px-2 py-px supports-bg-filter:bg-saturate-blur bg-white bg-opacity-75 supports-bg-filter:bg-opacity-25 text-black supports-bg-filter:text-white supports-bg-filter:text-shadow-black font-light text-sm leading-5 rounded-sm"
        >
          {{ tag.title }}
        </li>
      </ul>
    </router-link>
  </component>
</template>

<script>
import { mapState } from "vuex";

import findBySlug from "../../../store/getters/resolve/find-by-slug";

export default {
  name: "VideoPreview",
  props: {
    to: {
      type: Object,
      required: true,
    },
    video: {
      type: Object,
      required: true,
    },
    is: {
      type: String,
      default: "div",
    },
  },
  computed: {
    ...mapState(["container"]),
    tags() {
      return this.video.tags?.map((tag) =>
        findBySlug(this.container?.tags, tag.slug),
      );
    },
  },
  methods: {
    transformPublicUrl: (url) => (url?.includes("://") ? url : `/${url}`),
  },
};
</script>
